import React from 'react';
import { useFormContext } from 'react-hook-form';
import { useOrderSaleOrderRequestInputQuery } from '../../../../../../../../../services';
import { RhSingleAutocomplete } from '../../../../../../../../dum';
import { IOrderSale } from '../../../order-sale-form';
import { usePrefillFromClientAccount } from '../../../use-prefill-from-client-account';
import { useCalculateProductsTotal } from '../../../helpers/use-calculate-products-total';
import { FIELD_LABELS, shortLabel } from '../../../../../../../../../helpers';

const ACCOUNT_NAME: keyof IOrderSale = 'account';
const ORDER_SALE_PRODUCTS: keyof IOrderSale = 'order_sale_products';

export function CreateOrderRequestInput() {
    const inputName: keyof IOrderSale = 'order_request';
    const { data } = useOrderSaleOrderRequestInputQuery();

    const rhContext = useFormContext();
    const { prefillFromAccount } = usePrefillFromClientAccount();
    const { calculateProductsTotal } = useCalculateProductsTotal();

    const orderRequests: NonNullable<IOrderSale['order_request']>[] = data
        ? data.getOrderRequests
        : [];

    return (
        <RhSingleAutocomplete
            itemText={'order_code'}
            itemValue={'id'}
            name={inputName}
            label={shortLabel(FIELD_LABELS.order_request_id)}
            options={orderRequests}
            returnObject
            onChange={(val) => {
                const inputValue = val as IOrderSale['order_request'];

                rhContext.setValue(
                    ACCOUNT_NAME,
                    inputValue ? inputValue.account : null,
                );
                // The account comes from the picked request, so pre-fill the
                // sale's payment date + credit-note/supplement/tax defaults from
                // it too (mirrors picking a client account directly).
                prefillFromAccount(
                    (inputValue?.account ?? null) as IOrderSale['account'],
                );
                const orderSaleProducts: IOrderSale['order_sale_products'] =
                    inputValue?.order_request_remaining_products.map((osrp) => {
                        return {
                            groups: osrp.groups,
                            product: osrp.product || null,
                            kilos: osrp.kilos,
                            kilo_price: osrp.kilo_price,
                            total: osrp.total,
                            group_weight: osrp.group_weight,
                            group_price: osrp.group_price,
                        };
                    }) || [];
                rhContext.setValue(ORDER_SALE_PRODUCTS, orderSaleProducts);
                calculateProductsTotal();
            }}
        />
    );
}
